/**
 * Zeitauswahl (jquery.timepicker von WPForms) wie das Modern-Dropdown:
 * Liste so breit wie das Feld, Feld bekommt im geöffneten Zustand eine
 * Klasse (Rahmen/Radius siehe _forms.scss). Der Timepicker meldet Öffnen
 * und Schließen nur als jQuery-Events, daher jQuery statt addEventListener.
 */
(function () {
    function lhm_initWpformsTimepicker() {
        const $ = window.jQuery;
        if (!$) {
            return;
        }

        $(document)
            .on('showTimepicker', '.layoutformulare .ui-timepicker-input', function () {
                const $input = $(this);
                const $list = $input.data('timepicker-list');
                if (!$list) {
                    return;
                }

                $list.outerWidth($input.outerWidth());
                $input
                    .addClass('lhm-timepicker-open')
                    .toggleClass('lhm-timepicker-oben', $list.hasClass('ui-timepicker-positioned-top'));
            })
            .on('hideTimepicker', '.layoutformulare .ui-timepicker-input', function () {
                $(this).removeClass('lhm-timepicker-open lhm-timepicker-oben');
            });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', lhm_initWpformsTimepicker);
    } else {
        lhm_initWpformsTimepicker();
    }
})();
